import React, { useEffect, useState } from 'react';
import { Button, Input, Modal, Typography } from '@attentive-platform/stem-ui';

import { ReopenModalStyles as S } from './styles';

const CHOICES = [
  {
    id: 'internal',
    title: 'Reopen for internal edits only',
    body: 'Unlocks the form for fill-on-behalf and Copy link. No email goes to the customer.'
  },
  {
    id: 'notify',
    title: 'Reopen and notify the customer',
    body: 'Unlocks the form and sends one reopen notice with your reason as the why-line.'
  }
];

const ReopenModal = ({ open, onClose, onConfirm, submitting, emailsEnabled = true, customerEmail }) => {
  const [mode, setMode] = useState(null);
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (!open) return;
    setMode(null);
    setReason('');
  }, [open]);

  const reasonTrimmed = reason.trim();
  const notifyDisabled = !emailsEnabled;
  const canConfirm = !!mode && !!reasonTrimmed && !(mode === 'notify' && notifyDisabled);

  const handleConfirm = () => {
    if (!canConfirm || submitting) return;
    onConfirm({ mode, reason: reasonTrimmed, notifyCustomer: mode === 'notify' });
  };

  return (
    <Modal
      show={open}
      onClose={onClose}
      heading={<span className='pl-4'>Reopen scope form</span>}
      content={
        <S.ContentWrap>
          <S.Heading>How should this form reopen?</S.Heading>
          <Typography variant='body3' color='#4D4D4D' sx={{ lineHeight: 1.55 }}>
            Pick a path and leave a reason. The reason is required and is written to the change history
            {customerEmail ? ` for ${customerEmail}` : ''}.
          </Typography>

          <S.ChoiceStack>
            {CHOICES.map(choice => {
              const isNotify = choice.id === 'notify';
              const disabled = isNotify && notifyDisabled;
              const selected = mode === choice.id;
              const Choice = selected ? S.ChoiceOn : S.ChoiceOff;
              return (
                <Choice
                  key={choice.id}
                  type='button'
                  disabled={disabled}
                  onClick={() => {
                    if (disabled) return;
                    setMode(choice.id);
                  }}>
                  <S.ChoiceRadio aria-hidden selected={selected && !disabled} />
                  <S.ChoiceText>
                    <S.ChoiceTitle>{choice.title}</S.ChoiceTitle>
                    <S.ChoiceBody>
                      {disabled ? 'Emails are off for this record' : choice.body}
                    </S.ChoiceBody>
                  </S.ChoiceText>
                </Choice>
              );
            })}
          </S.ChoiceStack>

          <S.ReasonBlock>
            <Typography variant='body3' sx={{ fontWeight: 500 }} color='#4D4D4D'>
              Reason
            </Typography>
            <Input
              size='large'
              multiline
              minRows={3}
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder='Why is this form being reopened?'
            />
          </S.ReasonBlock>

          <S.Actions>
            <Button variant='outlined' color='primary' size='medium' onClick={onClose} disabled={submitting}>
              Cancel
            </Button>
            <Button
              variant='contained'
              color='primary'
              size='medium'
              loading={submitting}
              disabled={!canConfirm || submitting}
              onClick={handleConfirm}>
              Reopen
            </Button>
          </S.Actions>
        </S.ContentWrap>
      }
    />
  );
};

export default ReopenModal;
